import Swiper from 'swiper';

const Settings = function () {
  jQuery(document).ready(function ($) {

    if (jQuery('.support-slider-section').length > 0) {
      var mySwiper = new Swiper('.support-slider-section .swiper-container', {
        direction: 'horizontal',
        grabCursor: true,
        loop: false,
        init: false,
        slidesPerView: 1,
        autoHeight: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });

      mySwiper.init();
    }
  });

};

module.exports = Settings;